import { render, staticRenderFns } from "./TypeaheadPortfolioSearch.vue?vue&type=template&id=6b92c205&"
import script from "./TypeaheadPortfolioSearch.vue?vue&type=script&lang=js&"
export * from "./TypeaheadPortfolioSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports